import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export const VpPageTitle = ({ title, subtitle, rightContent }) => {
  const leftContent = (
    <Stack spacing="5px">
      {title && <Typography variant="pageTitle">{title}</Typography>}
      {subtitle && <Typography variant="pageSubTitle">{subtitle}</Typography>}
    </Stack>
  );

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      {leftContent}
      {rightContent}
    </Stack>
  );
};

VpPageTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  rightContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

export default VpPageTitle;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPageTitle/VpPageTitle.jsx